// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Login - POST /auth/login */
export async function login(
  body: USER_API.LoginParams,
  options?: { [key: string]: any },
): Promise<USER_API.LoginResponse> {
  return request<USER_API.LoginResponse>(`/v1/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Current User - GET /auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  return request<USER_API.User>(`/v1/auth/me`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Register - POST /auth/register */
export async function register(body: USER_API.RegisterParams, options?: { [key: string]: any }) {
  return request<USER_API.User>(`/v1/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Change Password - POST /auth/change-password */
export async function changePassword(
  body: USER_API.ChangePasswordType,
  options?: { [key: string]: any },
) {
  return request(`/v1/auth/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Generate 2fa - POST /auth/2fa/generate */
export async function generate2fa(options?: { [key: string]: any }): Promise<string> {
  return request<string>(`/v1/auth/2fa/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    ...(options || {}),
  });
}

/** Enable 2fa - POST /auth/2fa/enable */
export async function enable2fa(body: USER_API.TwoFaParams, options?: { [key: string]: any }) {
  return request(`/v1/auth/2fa/enable`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Verify 2fa Login - POST /auth/2fa/login */
export async function login2fa(body: USER_API.TwoFaParams, options?: { [key: string]: any }) {
  return request(`/v1/auth/2fa/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Resend Verify Email - POST /email-verify/resend */
export async function resendVerify(email: string, options?: { [key: string]: any }) {
  return request(`/v1/email-verify/resend`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      email,
    },
    ...(options || {}),
  });
}

/** Update Min Payout- PUT /users/usdt-min-payout */
export async function updateMinPayout(newAmount: number, options?: { [key: string]: any }) {
  return request(`/v1/users/usdt-min-payout`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      amount: newAmount,
    },
    ...(options || {}),
  });
}

/** Update Min Payout- PUT /users/fee-rate */
export async function updateFeeRate(feeRate: number, code: string, options?: { [key: string]: any }) {
  return request(`/v1/users/fee-rate`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      feeRate,
      code,
    },
    ...(options || {}),
  });
}

/** Update WebHook URL- PUT /users/webhook-url */
export async function updateWebHookUrl(
  newUrl: string,
  code: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/webhook-url`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      url: newUrl,
      code,
    },
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Update Withdraw WebHook URL- PUT /users/withdraw-webhook-url */
export async function updateWithdrawWebHookUrl(
  newUrl: string,
  code: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/withdraw-webhook-url`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      url: newUrl,
      code,
    },
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Update WhiteList Wallet Address
 * PUT /users/usdt-whitelist-address */
export async function updateWhiteListAddress(
  newAddress: string,
  code: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/usdt-whitelist-address`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      address: newAddress,
      code,
    },
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Get User Settings - GET /users/settings */
export async function getUserSettings(options?: { [key: string]: any }) {
  return request<USER_API.UserSettingsType>(`/v1/users/settings`, {
    method: 'GET',
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Update Merchant Consolidation Settings - PUT /v1/users/merchant-consolidation-settings */
export async function updateMerchantConsolidationSettings(
  body: USER_API.UpdateMerchantConsolidationSettingsDto,
  code: string, // For 2FA
  options?: { [key: string]: any },
) {
  return request(`/v1/users/merchant-consolidation-settings`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
      code,
    },
    ...(options || {}),
  });
}

/** Update Notification Email - PUT /users/notification-email */
export async function updateNotificationEmail(
  notificationEmail: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/notification-email`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      notificationEmail,
    },
    skipErrorHandler: true,
    ...(options || {}),
  });
}


/** Add Sub Users */
export async function addSubUser(
  body: USER_API.CreateSubUser,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/create-sub-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Get Sub Users */
export async function fetchSubUsers(page = 1, take = 10, options?: { [key: string]: any }) {
  const query = new URLSearchParams({ page: `${page}`, take: `${take}`, ...options }).toString();
  return request<USER_API.UserList>(`/v1/users/sub-users?${query}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Get Sub User Permissions */
export async function fetchSubUserRolePermissions(options?: { [key: string]: any}) {
  return request<USER_API.PERMISSIONS[]>(`/v1/role/subuser/permissions`, {
    method: 'GET',
    skipErrorHandler: true,
    ...(options || {}),
  });
}


/** Remove Sub User */
export async function removeSubUser(id: string, options?: { [key: string]: any }) {
  return request(`/v1/users/sub-users/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** Add Sub User Permission  */
export async function addSubUserPermission(
  id: string,
  permission: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/sub-users/${id}/permissions/${permission}`, {
    method: 'DELETE',
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** Revoke sub-user Permissions */
export async function revokeSubUserPermissions(
  subUserId: string,
  permission: string,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/sub-users/revoke-permission`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      subUserId,
      permission,
    },
    ...(options || {}),
  });
}

/** Update User Withdraw Requst Settings */
export async function updateUserWithdrawRequestSettings(
  enabled: boolean,
  minAutoApproveAmount: number,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/withdraw-request-status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      withdrawRequestEnabled: enabled,
      minAutoApproveAmount,
    },
    ...(options || {}),
  });
}

/** Update Withdraw Request Reference Prefix Check */
export async function updateWithdrawRequestReferencePrefixCheck(withdrawReferenceCheckPrefixLength: number, options?: { [key: string]: any }) {
  return request(`/v1/users/withdraw-reference-prefix-check`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      withdrawReferenceCheckPrefixLength,
    },
    ...(options || {}),
  });
}

/** Update Tron Energy Rental Settings */
export async function updateTronEnergyRentSettings(
  enableTronEnergyRentalConsolidateFee: boolean,
  enableTronEnergyRentalConsolidateFund: boolean,
  options?: { [key: string]: any },
) {
  return request(`/v1/users/enable-energy-rent`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      enableTronEnergyRentalConsolidateFee,
      enableTronEnergyRentalConsolidateFund,
    },
    skipErrorHandler: true,
    ...(options || {}),
  });
}
